import React from "react";

export default function EmptyDiv() {
  return <div style={{ width: "100%" }}></div>;
}
